const emptyService = () => ({
  tipo: '',
  servicoDetalhado: '',
  valorServicoDetalhado: '',
  observacao: '',
});

const emptyDistrict = () => ({ vendedor: '', estado: '' });

export const initialNucleoRequestForm = () => ({
  quantidade_servicos: '',
  servico: [],
  onus_solicitada: '',
  justificativa_onus: '',
  vendedor_comarca: '',
  quantidade_comarca: '',
  vendedores_comarca: [],
});

const resized = (values, count, factory) =>
  Array.from(
    { length: Number(count) || 0 },
    (_, index) => values[index] || factory()
  );

export const setServiceCount = (form, value) => ({
  ...form,
  quantidade_servicos: value,
  servico: resized(form.servico, value, emptyService),
});

export const updateService = (form, index, field, value) => {
  const services = form.servico.map(service => ({ ...service }));
  services[index][field] = value;
  if (field === 'tipo') {
    services[index].servicoDetalhado = '';
    services[index].valorServicoDetalhado = '';
  }
  if (field === 'servicoDetalhado') services[index].valorServicoDetalhado = '';
  return { ...form, servico: services };
};

export const setDistrictCount = (form, value) => ({
  ...form,
  quantidade_comarca: value,
  vendedores_comarca: resized(form.vendedores_comarca, value, emptyDistrict),
});

export const updateCondition = (form, field, value) => {
  const next = { ...form, [field]: value };
  if (field === 'onus_solicitada' && value === '1')
    next.justificativa_onus = '';
  if (field === 'vendedor_comarca' && value === '0') {
    next.quantidade_comarca = '';
    next.vendedores_comarca = [];
  }
  return next;
};

export const updateDistrict = (form, index, field, value) => ({
  ...form,
  vendedores_comarca: form.vendedores_comarca.map((row, rowIndex) =>
    rowIndex === index ? { ...row, [field]: value } : row
  ),
});
